import { getLocalStorage, setLocalStorage } from './storage';

function saveAssetInLocalStorage(assetId, data) {
  const localStorage = getLocalStorage();
  const existingData = localStorage[assetId] || {};

  const { assetFiles: existingAssetFiles = {} } = existingData;
  const { assetFiles } = data;

  const mergedAssetFiles = { ...existingAssetFiles, ...assetFiles };

  localStorage[assetId] = { ...existingData, ...data, ...{ assetFiles: mergedAssetFiles } };

  setLocalStorage(localStorage);
}

export default saveAssetInLocalStorage;